export const GUIDE_STAGES = [
  'video_upload', 'video_review', 'rippling_onboarding',
  'financial_review', 'approved',
] as const;
export type GuideStage = typeof GUIDE_STAGES[number];

export const STAGE_LABEL: Record<GuideStage, string> = {
  video_upload:        'Awaiting guide: video + résumé',
  video_review:        'Video review',
  rippling_onboarding: 'Waiting on Rippling',
  financial_review:    'Ready for final approval',
  approved:            'Approved',
};

/** Stages where the ball is in the guide's court (nothing for the admin to action). */
export function isGuideInputStage(s: string | null): boolean {
  return s === 'video_upload';
}
